import logger from '@goldcast/logger';

import store from '@/store';
import { CurrentOrganization } from '@/store/modules/org';

export function checkAndShowSalesforceConfig(): { query: Record<string, string> } {
  try {
    const currentOrg = store.getters['org/getCurrentOrg'] as CurrentOrganization;
    const shouldShowSalesforceModal = currentOrg?.useSalesforceCampaignCreationCustomSolution || false;
    const query: Record<string, string> = shouldShowSalesforceModal ? { showSalesforceModal: 'true' } : {};
    return { query };
  } catch (error) {
    logger.error('Error checking and showing Salesforce config', error);
    return { query: {} };
  }
}
